import script from "./DHeart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DHeart.vue?vue&type=script&setup=true&lang=ts"

import "./DHeart.vue?vue&type=style&index=0&id=bc358baa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc358baa"]])

export default __exports__